






























import Vue from "vue";
import ePaid from "./Projects/ePaid.vue";
import FlySafe from "./Projects/FlySafe.vue";
import grow from "./Projects/grow.vue";
import SearchEngine from "./Projects/SearchEngine.vue";
import sliai from "./Projects/sliai.vue";
import TableStory from "./Projects/TableStory.vue";
import SimuStep from "./Projects/SimuStep.vue";
import MLFakeNews from "./Projects/MLFakeNews.vue";

export default Vue.extend({
  name: "projects",
  components: {
    ePaid,
    FlySafe,
    grow,
    SearchEngine,
    sliai,
    TableStory,
    SimuStep,
    MLFakeNews,
  },
});
